/**
 * Feature unlock flags a dev/admin can `/give`. Stored under the synced key
 * `hambi.flags` (JSON string array) and honored by the gates in ShopScene.
 * The server-side allowlist in dev_give must match this list.
 */
export const FEATURE_FLAGS = ['shop2', 'evolve', 'hub', 'potionshop'] as const;
export type FeatureFlag = (typeof FEATURE_FLAGS)[number];

export function isFeatureFlag(x: unknown): x is FeatureFlag {
  return typeof x === 'string' && (FEATURE_FLAGS as readonly string[]).includes(x);
}
